module.exports = "/_next/static/images/b7524eae8d5fc69e920dd6babed5d282-bars-lg.jpg";